import {array, boolean, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {
  localizedTextOptionalNullable,
  localizedTextRequired,
  stringOptionalNullable,
} from '@shared/utils';
import {subCategoryV8nSchema} from '../../category/api/backendSchemas';

export const topicV8nSchema = object().shape({
  id: string().required(),
  topic_id: stringOptionalNullable,
  topic_slug: stringOptionalNullable,
  name: localizedTextRequired,

  short_name: localizedTextOptionalNullable,
  logo_url: stringOptionalNullable,

  banner_url: stringOptionalNullable,
  stream_url: stringOptionalNullable,
  category_banner_url: stringOptionalNullable,
  category_logo_url: stringOptionalNullable,

  category_name: localizedTextOptionalNullable,
  category_slug: stringOptionalNullable,
  subcategories: array().of(subCategoryV8nSchema).nullable().optional(),
  // Returned by GET /admin/topics/{slug} only, not by the list endpoint.
  geo_slugs: array().of(string().required()).nullable().optional(),
  start_date: string().required(),
  end_date: stringOptionalNullable,

  is_live: boolean().nullable(),
  is_favorite: boolean().nullable(),
  auto_publish_enabled: boolean().nullable().optional(),
  trading_volume: number().nullable(),
  published_events_count: number().nullable(),
  created_at: stringOptionalNullable,
});

export const v8nSchemaOfGetTopicsResponse = paginationV8nSchema.shape({
  array: array().of(topicV8nSchema),
});
